var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.18691 9.11939L9.67627 5.63003L9.79416 5.74876L5.83335 9.70957L4.20713 8.08334L4.3232 7.96726L5.48048 9.12007L5.83404 9.47226L6.18691 9.11939ZM1.66669 7.5C1.66669 4.55615 4.05616 2.16667 7.00002 2.16667C9.94388 2.16667 12.3334 4.55615 12.3334 7.5C12.3334 10.4439 9.94388 12.8333 7.00002 12.8333C4.05616 12.8333 1.66669 10.4439 1.66669 7.5ZM1.83335 7.5C1.83335 10.3486 4.15138 12.6667 7.00002 12.6667C9.84866 12.6667 12.1667 10.3486 12.1667 7.5C12.1667 4.65136 9.84866 2.33334 7.00002 2.33334C4.15138 2.33334 1.83335 4.65136 1.83335 7.5Z",
    fill: "#545D5B",
    stroke: "#545D5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check_circle_outline.0419f5f479f0efee920c4ed35406489e.svg";
export { ForwardRef as ReactComponent };